import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const Info = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg viewBox="0 0 32 32" {...props}>
    <path id="a" d="M4,16a12,12 0 1,0 24,0a12,12 0 1,0 -24,0" />
    <path d="M14.5 13v-3h3v3h-3zm0 9v-6h3v6h-3z" id="b" />
  </svg>
);

const InfoIcon = styled(Info)`
  width: ${({ size = '1rem' }) => size};
  min-width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  min-height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;

export default InfoIcon;
